import ExtendableTable from '@/components/ExtendableTable';
import InlineEdit from '@/components/InlineEdit';
import { useDocumentContext } from '@/contexts/DocumentContext';
import useCognitoUsers from '@/hooks/useCognitoUsers';
import { filterUsersByRole } from '@/lib/approvals';

const ApprovalsTable = ({
  hideButtons: hideButtonsProp,
  name,
  required,
  title,
  users,
}) => {
  const { form, isPreview, setFormByKey } = useDocumentContext();

  const filteredUsers = filterUsersByRole(users, name);

  const selectedOptions = form[name]?.map((row) => row.value?.sub) || [];

  return (
    <div className="space-y-4">
      <h4 className="mb-3 font-bold">
        {title}
        {required && <span className="text-destructive"> *</span>}
      </h4>
      <ExtendableTable
        columns={[
          {
            className: 'w-14',
            label: 'S/N',
            name: 'series',
            renderField: (_, index) => (
              <div className="text-center">
                {String(index + 1).padStart(2, '0')}
              </div>
            ),
          },
          {
            className: 'w-2/5',
            label: 'Name',
            name: 'sub',
            renderField: ({ onChange, value }) => (
              <InlineEdit
                disabled={isPreview}
                onChange={(sub) => {
                  const user = filteredUsers.find((u) => u.sub === sub);
                  onChange(user ? { sub: user.sub, name: user.name, designation: user.designation } : { sub, name: sub });
                }}
                options={filteredUsers.map((item) => ({
                  ...item,
                  disabled: selectedOptions.includes(item.sub),
                }))}
                placeholder={isPreview ? '' : 'Select name...'}
                type="select"
                value={value}
              />
            ),
          },
          {
            label: 'Designation',
            name: 'designation',
            renderField: (_, __, fieldValue) => (
              <div>
                {fieldValue?.designation || '\u2014'}
              </div>
            ),
          },
        ]}
        disabled={isPreview}
        hideButtons={isPreview || hideButtonsProp}
        onChange={(value) => setFormByKey(name, value)}
        value={form[name]}
      />
    </div>
  );
};

const DocumentApprovalsView = () => {
  const { users } = useCognitoUsers();

  return (
    <div className="space-y-4">
      <ApprovalsTable
        hideButtons
        name="approvalsAssigned"
        required
        title="QMR or Assigned QA for Review"
        users={users}
      />
      <ApprovalsTable
        name="approvalsOwner"
        required
        title="List of Process Owner(s) for Review"
        users={users}
      />
      <ApprovalsTable
        name="approvalsPersonnel"
        required
        title="Management or Assigned Personnel for Approval"
        users={users}
      />
    </div>
  );
};

export default DocumentApprovalsView;
